import PropTypes from 'prop-types';

/** Tile stand-in for a file that is mid-upload, so the grid does not jump when it lands. */
const ImageUploadProgressTile = ({ name, progress, error }) => (
  <div className="relative flex aspect-[4/3] flex-col items-center justify-center gap-2 overflow-hidden rounded-lg bg-gray-10 px-3">
    {error ? (
      <>
        <p className="text-sm font-medium text-red-400">Upload failed</p>
        <p className="line-clamp-2 text-center text-xs text-gray-600">{error}</p>
        <p className="line-clamp-1 text-xs text-gray-400">{name}</p>
      </>
    ) : (
      <>
        <p className="line-clamp-1 w-full text-center text-xs text-gray-600">{name}</p>
        <span className="text-sm font-medium text-gray-800">{progress}%</span>
        <div className="h-1.5 w-2/3 overflow-hidden rounded-full bg-white-100">
          <div className="h-full rounded-full bg-primary-500 transition-all" style={{ width: `${progress}%` }} />
        </div>
      </>
    )}
  </div>
);

ImageUploadProgressTile.propTypes = {
  name: PropTypes.string.isRequired,
  progress: PropTypes.number,
  error: PropTypes.string,
};

ImageUploadProgressTile.defaultProps = {
  progress: 0,
  error: '',
};

export default ImageUploadProgressTile;
